/**
 * Created by Ning Jiang on 2021-05-03.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap, TweenLite} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {LoopableList} from "../utils/LoopableList";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {SoundEffectGroup} from "./SoundEffectGroup";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class DevilsCrossRoadSound {

    public static readonly AS_WIN:string = "asWin";
    public static readonly AS_WIN_BIG:string = "asWinBig";

    public static MAIN_GAME_MUSIC:string = "main";
    public static MAIN_GAME_AVALANCHE:string = "mainAvalanche";
    public static BONUS_GAME_MUSIC:string = "fs";

    public static MAIN_GAME_SPINNING:string = "mainSpinning";
    public static MAIN_GAME_SPINNING_STOP:string = "mainSpinningStop";
    public static REELS_OUT:string = "reelsOut";

    public static panningSymbolLanding:number[][] = [[0.00, -0.35, -0.35, -0.35, 0.00], [-0.18, 0.00, -0.18, 0.00, -0.18], [0.00, 0.00, 0.00, 0.00, 0.00], [0.18, 0.00, 0.18, 0.00, 0.18], [0.00, 0.35, 0.35, 0.35, 0.00]];

    public static MULTIPLIER_MOVING:string = "multiplierMoving";
    public static SYMBOL_WIN_MULTI:string = "symbolWinMulti";
    public static WIN_REMOVE:string = "winRemove";
    public static SYMBOL_AVALANCHE:string = "symsMove";

    public static WILD_LAND:string = "wildLand";
    public static WILD_REMOVE:string = "wildRemove";

    public static SCATTER_LAND:string[] = ["scatterLand1", "scatterLand2", "scatterLand3", "scatterLand4"];
    public static SCATTER_ANTICIPATION:string = "scatterAnticipation";
    public static SCATTER_ANTICIPATION_PAUSE:string = "scatterAnticipationPause";
    public static SCATTER_ANTICIPATION_FAIL:string = "scatterAnticipationFail";

    public static SCATTERS_WIN_FS:string = "scatterCompleteFS";
    public static SCATTERS_WIN_SFS:string = "scatterCompleteSFS";

    public static FS_INTRO_MUSIC:string = "fsIntro";
    public static SFS_INTRO_MUSIC:string = "sfsIntro";

    public static FS_REEL_SPIN_START:string = "fsReelsSpin";
    public static FS_REEL_SPIN_LOOP:string = "fsReelsSpinningLoop";
    public static FS_REEL_SPIN_STOP:string = "fsSpinningStop";

    public static BIG_WIN_INTRO:string = "bigwinIntro";
    public static BIG_WIN_END:string = "bigwinEnd";
    public static BIG_WIN_MUSICS:string[] = ["bigwin1", "bigwin2", "bigwin3", "bigwin4", "bigwin5"];
    public static CONTINUE_BUTTON:string = "continueButton";

    public static BONUS_ENDS_GOOD:string = "fsEndsGood";
    public static BONUS_ENDS_BAD:string = "fsEndsBad";

    public static MAX_WIN_LOOP: string = "capwinLoop";
    public static MAX_WIN_COUNTUP: string = "capwinCountup";
    public static MAX_WIN_END: string = "capwinEnd";
    public static MAX_WIN_FIREWORKS: string = "capwinFireworks";

    public static FS_COIN_LAND1:string = "fsCoin1Land";
    public static FS_COIN_LAND5:string = "fsCoin5Land";
    public static FS_COIN_LAND20:string = "fsCoin20Land";
    public static FS_COIN_LAND100:string = "fsCoin100Land";
    public static FS_COIN_SEND:LoopableList<string> = new LoopableList<string>(["fsCoinSend01", "fsCoinSend02", "fsCoinSend03", "fsCoinSend04"]).setRandomizeAtWrapAround(true);
    public static FS_COIN_UPDATE:string[] = ["fsCoinUpdate1", "fsCoinUpdate2", "fsCoinUpdate3", "fsCoinUpdate4"];
    public static FS_COIN_SELECT:string = "fsCoinSelect";
    public static FS_COIN_MULTIPLIER:string = "fsMultiplier";
    public static FS_COIN_MULTIPLIER_FINAL:string = "fsMultiplierFinal";
    public static FS_DEVIL_COIN_LAND:string = "fsDevilcoinLand";
    public static FS_DEVIL_COIN_ANTICIPATION:string = "fsDevilcoinAnticipation";
    public static FS_LOOP_END:string = "fsLoopEnd";
    public static FS_MULTIPLIER_COUNTUP:string = "fsMultiplierCountup";
    public static FS_ENDS_COUNTUP:string = "fsEndsCountup";
    public static FS_ROW_FILLED:string = "fsRowFilled";
    public static FS_SPINS_RESET: string = "fsSpinsReset";

    public static FS_FEATURE_REVEAL_F3:string = "fsFeatureRevealLust";
    public static FS_PROGRESS_METER_LEVEL:string[] = ["fsProgress1", "fsProgress2", "fsProgress3", "fsProgress4"];
    public static FS_FEATURE_REVEAL_F2:string = "fsFeatureRevealWrath";
    public static FS_FEATURE_REVEAL_F4:string = "fsFeatureRevealGreed";
    public static FS_FEATURE_REVEAL_F5:string = "fsFeatureRevealEnvy";
    public static FS_FEATURE_REVEAL_F6:string = "fsFeatureRevealPride";
    public static FS_FEATURE_ACTIVATE:string = "fsFeatureActivateFlash";
    public static FS_FEATURE_REVEAL_FLASH:string = "fsFeatureRevealFlash";

    public static FS_FEATURE_FAIL:LoopableList<string> = new LoopableList<string>(["fsFeatureFail01", "fsFeatureFail02", "fsFeatureFail03", "fsFeatureFail04"]).setRandomizeAtWrapAround(true);

    public static SFS_FEATURE_ROW_UNLOCKED:string = "fsRowUnlocked";

    public static SYM_LANDING:LoopableList<string> = new LoopableList<string>(["symLand01", "symLand02", "symLand03", "symLand04", "symLand05", "symLand06", "symLand07", "symLand08", "symLand09", "symLand10"]).setRandomizeAtWrapAround(true);
    public static FS_EMPTY_SYM_LANDING:LoopableList<string> = new LoopableList<string>(["fsEmptyLand01", "fsEmptyLand02", "fsEmptyLand03", "fsEmptyLand04", "fsEmptyLand05", "fsEmptyLand06", "fsEmptyLand07", "fsEmptyLand08", "fsEmptyLand09", "fsEmptyLand10", "fsEmptyLand11"]).setRandomizeAtWrapAround(true);
    public static FS_REEL_LAND:LoopableList<string> = new LoopableList<string>(["fsReelLand01", "fsReelLand02", "fsReelLand03", "fsReelLand04", "fsReelLand05"]).setRandomizeAtWrapAround(true);

    public static get soundPlayer():NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    constructor() {
        if(NolimitConfig.isDevMode) {
            DevilsCrossRoadSound.soundPlayer.showLogs(true);
        }
        NolimitSlotAudio.apiPlugIn.settings.on(APISetting.SFX, (value:any) => this.onSFX(value));
    }

    private static _currentMusic:string;

    public static switchMusic(conf:IPlayTrackConf, fadeInConf?:IFadeTrackConf, fadeOutConf?:IFadeTrackConf):void {
        if(fadeInConf && fadeInConf.name != conf.name) {
            debugger;
            Logger.logDev(`WARNING: switching music fade in conf name doesn't match the new music name!`);
        }

        if(conf.name === DevilsCrossRoadSound._currentMusic) {
            if(fadeInConf) {
                DevilsCrossRoadSound.soundPlayer.fadeTrack(fadeInConf);
                if(DevilsCrossRoadSound._currentMusic === DevilsCrossRoadSound.MAIN_GAME_MUSIC) {
                    DevilsCrossRoadSound.stopAvalancheTimer();
                    DevilsCrossRoadSound.soundPlayer.fadeTrack({
                        name : DevilsCrossRoadSound.MAIN_GAME_AVALANCHE,
                        from : fadeInConf.from,
                        to : 0,
                        duration : fadeInConf.duration
                    });
                }
            }
            return;
        }

        if(DevilsCrossRoadSound._currentMusic != null) {
            if(fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade = DevilsCrossRoadSound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = this._currentMusic;
                if(fade) {
                    gsap.to(this, {
                        duration : fadeOutConf.duration / 1000,
                        onComplete : () => {
                            DevilsCrossRoadSound.soundPlayer.stopTrack(fadeName);
                        }
                    });
                    if(fadeName === DevilsCrossRoadSound.MAIN_GAME_MUSIC) {
                        DevilsCrossRoadSound.stopAvalancheTimer();
                        DevilsCrossRoadSound.soundPlayer.fadeTrack({
                            name : DevilsCrossRoadSound.MAIN_GAME_AVALANCHE,
                            from : fadeOutConf.from,
                            to : 0,
                            duration : fadeOutConf.duration
                        });
                        gsap.to(this, {
                            duration : fadeOutConf.duration / 1000,
                            onComplete : () => {
                                DevilsCrossRoadSound.stopAvalancheTimer();
                                DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.MAIN_GAME_AVALANCHE);
                            }
                        });
                    }
                } else {
                    DevilsCrossRoadSound.soundPlayer.stopTrack(fadeName);
                    if(fadeName === DevilsCrossRoadSound.MAIN_GAME_MUSIC) {
                        DevilsCrossRoadSound.stopAvalancheTimer();
                        DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.MAIN_GAME_AVALANCHE);
                    }
                }
            } else {
                DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound._currentMusic);
                if(DevilsCrossRoadSound._currentMusic === DevilsCrossRoadSound.MAIN_GAME_MUSIC) {
                    DevilsCrossRoadSound.stopAvalancheTimer();
                    DevilsCrossRoadSound.soundPlayer.stopTrack(DevilsCrossRoadSound.MAIN_GAME_AVALANCHE);
                }
            }
            Logger.logDev(DevilsCrossRoadSound._currentMusic, " sound loop switched to ", conf.name);
        }

        DevilsCrossRoadSound.soundPlayer.playTrack(conf);
        if(conf.name === DevilsCrossRoadSound.MAIN_GAME_MUSIC) {
            DevilsCrossRoadSound.stopAvalancheTimer();
            DevilsCrossRoadSound.soundPlayer.playTrack({
                name : DevilsCrossRoadSound.MAIN_GAME_AVALANCHE,
                volume : 0
            });
        }
        if(fadeInConf) {
            DevilsCrossRoadSound.soundPlayer.fadeTrack(fadeInConf);
        }
        DevilsCrossRoadSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol:number, duration:number):void {
        DevilsCrossRoadSound.soundPlayer.fadeTrack({
            name : DevilsCrossRoadSound._currentMusic,
            to : vol,
            duration : duration
        });
        if(DevilsCrossRoadSound._currentMusic === DevilsCrossRoadSound.MAIN_GAME_MUSIC) {
            DevilsCrossRoadSound.stopAvalancheTimer();
            DevilsCrossRoadSound.soundPlayer.fadeTrack({
                name : DevilsCrossRoadSound.MAIN_GAME_AVALANCHE,
                to : 0,
                duration : duration
            });
        }
    }

    public static getMusicNameByMode(mode:GameMode | string):string {
        switch(mode) {
            case DevilsCrossRoadSound.SFS_INTRO_MUSIC:
                return DevilsCrossRoadSound.SFS_INTRO_MUSIC;
            case DevilsCrossRoadSound.FS_INTRO_MUSIC:
                return DevilsCrossRoadSound.FS_INTRO_MUSIC;
            case DevilsCrossRoadGameMode.FREESPIN:
                return DevilsCrossRoadSound.BONUS_GAME_MUSIC;
            case DevilsCrossRoadGameMode.SUPER_FREESPIN:
                return DevilsCrossRoadSound.BONUS_GAME_MUSIC;
            case DevilsCrossRoadGameMode.NORMAL:
                return DevilsCrossRoadSound.MAIN_GAME_MUSIC;
            default:
                return DevilsCrossRoadSound.MAIN_GAME_MUSIC;
        }
    }

    public static fadeAndStopSound(fadeOutConf:IFadeTrackConf):void {
        const fade = DevilsCrossRoadSound.soundPlayer.fadeTrack(fadeOutConf);
        if(fade) {
            gsap.to(this, {
                duration : fadeOutConf.duration / 1000,
                onComplete : () => {
                    DevilsCrossRoadSound.soundPlayer.stopTrack(fadeOutConf.name);
                }
            });
        } else {
            DevilsCrossRoadSound.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }

    public static PLAYING_LOOP_EFFECTS:string[] = [];

    private onSFX(value:any):void {
        if(!DevilsCrossRoadSound.soundPlayer.isLoaded) {
            return;
        }
        if(!NolimitSlotAudio.apiPlugIn.settings.get("mute")) {
            return;
        }
        if(!value) {
            return;
        }
        DevilsCrossRoadSound.PLAYING_LOOP_EFFECTS.forEach(name => {
            DevilsCrossRoadSound.playLoopEffect(name);
        });
    }

    // play loop effect even the trigger is when sound is off, it will play when sound is on.
    public static playLoopEffect(name:string):void {
        if(DevilsCrossRoadSound.PLAYING_LOOP_EFFECTS.indexOf(name) === -1) {
            DevilsCrossRoadSound.PLAYING_LOOP_EFFECTS.push(name);
        }
        const player = DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(name);
        if(player && !player.isPlaying) {
            DevilsCrossRoadSound.soundPlayer.playTrack({name : name, repeat : 1000});
        }
    }

    public static stopLoopEffect(name:string, fade:boolean = false, to?:number, duration?:number, from?:number):void {
        ArrayHelper.removeFirstMatchElement(DevilsCrossRoadSound.PLAYING_LOOP_EFFECTS, name);
        if(fade) {
            DevilsCrossRoadSound.fadeAndStopSound({
                name : name,
                to : to ? to : 0,
                duration : duration ? duration : 100,
                from : 1
            });
        } else {
            DevilsCrossRoadSound.soundPlayer.stopTrack(name);
        }
    }

    public static getWinSoundName(level:number):string {
        switch(level) {
            case 0:
                return "winTiny";
            case 1:
                return "winSmall";
            case 2:
                return "winMediumCountUp";
            default:
                return "winLargeCountUp";
        }
    }

    public static getWinEndSoundName(level:number):string {
        switch(level) {
            case 0:
            case 1:
                return "";
            case 2:
                return "winMediumEnd";
            default:
                return "winLargeEnd";
        }
    }

    public static playSymLandingSound(reelId:number, rowId:number):void {
        const soundName:string = DevilsCrossRoadSound.SYM_LANDING.next();
        const sound:NolimitHowl | undefined = this.soundPlayer.playTrack({name : soundName, volume : 1, repeat : 0});
        if(sound) {
            sound.player.stereo(this.panningSymbolLanding[reelId][rowId]);
            Logger.logDev("panning Value", this.panningSymbolLanding[reelId][rowId]);
        }
    }

    public static playBonsuSymEmptyLandingSound(id:number):void {
        const soundName:string = DevilsCrossRoadSound.FS_EMPTY_SYM_LANDING.next();
        const sound:NolimitHowl | undefined = this.soundPlayer.playTrack({name : soundName, volume : 1, repeat : 0});
        if(sound) {
            let panValue:number = 0.00;
            if(id < 6) {
                panValue = -0.35;
            } else if(id < 12) {
                panValue = -0.18;
            } else if(id < 18) {
                panValue = 0.00;
            } else if(id < 24) {
                panValue = 0.18;
            } else if(id < 30) {
                panValue = 0.35;
            }
            sound.player.stereo(panValue);
            Logger.logDev("panning Value", panValue);
        }
    }

    private static _winHighlightGroup:SoundEffectGroup;

    public static playWinHighlight():void {
        if(!DevilsCrossRoadSound._winHighlightGroup) {
            DevilsCrossRoadSound._winHighlightGroup = new SoundEffectGroup([
                "winHighlight01", "winHighlight02", "winHighlight03", "winHighlight04"
            ]);
        }
        DevilsCrossRoadSound._winHighlightGroup.play();
    }

    private static _winCombinationsGroup:SoundEffectGroup;

    public static playWinCombination():void {
        if(!DevilsCrossRoadSound._winCombinationsGroup) {
            DevilsCrossRoadSound._winCombinationsGroup = new SoundEffectGroup([
                "winCombination01", "winCombination02", "winCombination03", "winCombination04"
            ]);
        }
        DevilsCrossRoadSound._winCombinationsGroup.play();
    }

    private static _devilLaughGroup:SoundEffectGroup;

    public static playDevilLaugh():void {
        if(!DevilsCrossRoadSound._devilLaughGroup) {
            DevilsCrossRoadSound._devilLaughGroup = new SoundEffectGroup([
                "winDevilLaugh01", "winDevilLaugh02", "winDevilLaugh03"
            ]);
        }
        DevilsCrossRoadSound._devilLaughGroup.play();
    }

    private static _avalancheTimer:TweenLite;

    public static playAvalancheSound():void {
        const fade = DevilsCrossRoadSound.soundPlayer.fadeTrack({
            name : DevilsCrossRoadSound.MAIN_GAME_AVALANCHE,
            to : 1,
            duration : 500
        });
        if(fade) {
            DevilsCrossRoadSound.stopAvalancheTimer();
            DevilsCrossRoadSound._avalancheTimer = gsap.to(this, {
                duration : 20, onComplete : () => {
                    DevilsCrossRoadSound.soundPlayer.fadeTrack({
                        name : DevilsCrossRoadSound.MAIN_GAME_AVALANCHE,
                        to : 0,
                        duration : 7000
                    });
                }
            });
        }
    }

    private static stopAvalancheTimer():void {
        if(DevilsCrossRoadSound._avalancheTimer && DevilsCrossRoadSound._avalancheTimer.isActive()) {
            DevilsCrossRoadSound._avalancheTimer.pause();
            DevilsCrossRoadSound._avalancheTimer.kill();
        }
    }
}